// extracted by mini-css-extract-plugin
export default {"subscribe":"NoData_subscribe__tkZCO","break":"NoData_break__x2Kkl"};